import React from "react";
import './Footer.css';

export const Footer = ({ children }) =>
  <div className="footer text-center t-light">
    {children}
  </div>;